import { Button } from 'reactstrap';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { SurveyStatsFiltersProps, type SurveyStatsStatus } from '../types';
import { SURVEY } from '@constants/terminology';
import { DashboardRow } from '@g17eco/molecules/dashboard';
import type { FilterOptionsMap } from './constants';
import type { DataPeriods } from '@utils/dataPeriods';
import { SubsidiaryGroupSelect } from '@g17eco/molecules/select/SubsidiaryGroupSelect';
import type { InitiativePlain } from '@g17eco/types/initiative';

interface Props {
  filterOptions: FilterOptionsMap;
  filters: SurveyStatsFiltersProps;
  onMultiSelectChange: (data: Partial<SurveyStatsFiltersProps>) => void;
  onSaveFilters: () => void;
  initiativeId: string;
  subsidiaries: InitiativePlain[];
}

export const SurveyStatsFilters = (props: Props) => {
  const { filterOptions, filters, onMultiSelectChange, onSaveFilters, initiativeId, subsidiaries } = props;

  return (
    <DashboardRow classes={{ children: 'flex-lg-column' }}>
      <div className='d-flex gap-2 mb-2'>
        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Month'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ months: values })}
          options={filterOptions.months}
          values={filters.months || []}
        />

        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Year'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ years: values })}
          options={filterOptions.years}
          values={filters.years || []}
        />

        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder='Period'
          className='w-100'
          onChange={(values) => onMultiSelectChange({ periods: values as DataPeriods[] })}
          options={filterOptions.periods}
          values={filters.periods || []}
        />
      </div>
      <div className='d-flex gap-2 mb-2'>
        <SelectFactory
          selectType={SelectTypes.MultipleSelect}
          placeholder={`${SURVEY.CAPITALIZED_SINGULAR} Status`}
          className='w-100'
          onChange={(values) => onMultiSelectChange({ surveyStatuses: values as SurveyStatsStatus[] })}
          options={filterOptions.surveyStatuses}
          values={filters.surveyStatuses || []}
        />
        <div className='w-100'>
          <SubsidiaryGroupSelect
            initiativeId={initiativeId}
            subsidiaries={subsidiaries}
            selectedSubsidiaryIds={filters.initiatives || []}
            onChange={(values) => onMultiSelectChange({ initiatives: values })}
            placeholder='Subsidiaries'
          />
        </div>
        <Button color='primary' className='text-nowrap' size='sm' onClick={onSaveFilters}>
          <i className='fal fa-floppy-disk mr-2' />
          Save filters
        </Button>
      </div>
    </DashboardRow>
  );
};
